import { useEffect, useRef } from 'react';

import settings from '@/constants/constants';
import useGetZendeskToken from '@/hooks/zendesk/useGetZendeskToken';

// zE is attached to the window object by the Zendesk messaging widget during initilization
declare global {
  interface Window {
    zE: (widget: string, command: string, callback?: (fn: (token?: string) => void) => void) => void;
  }
}

function ZendeskChatWidget() {
  const scriptRef = useRef<HTMLScriptElement | null>(null);
  const { data } = useGetZendeskToken();

  useEffect(() => {
    if (!scriptRef.current) {
      const script = document.createElement('script');

      script.id = 'ze-snippet';
      script.src = `https://static.zdassets.com/ekr/snippet.js?key=${settings.ZENDESK_MESSAGING_KEY}`;
      script.async = true;

      document.body.appendChild(script);
      scriptRef.current = script;
    }

    return () => {
      if (scriptRef.current) {
        document.body.removeChild(scriptRef.current);
        scriptRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (window.zE && data?.token) {
      window.zE('messenger', 'loginUser', (cb) => cb(data.token));
    }
  }, [data]);

  return null;
}

export default ZendeskChatWidget;
